import validator from "validator";
import { VALID_ZIP_CODES } from "../constants";

export const validateEmail = (value?: any) => {
  return value && validator.isEmail(value);
};

export const validateOptionalSecondaryEmail = (
  value?: any,
  primaryEmail?: any
) => {
  if (!value) return true;
  const normalizedValue = String(value).trim();
  if (!validateEmail(normalizedValue)) return false;

  return (
    normalizedValue.toLowerCase() !==
    String(primaryEmail || "").trim().toLowerCase()
  );
};

export const validatePassword = (value?: any) => {
  return value && value.length >= 6;
};

export const normalizeCustomerName = (value?: any) => {
  return typeof value === "string" ? value.trim().replace(/\s+/g, " ") : "";
};

export const validateCustomerName = (value?: any) => {
  const normalized = normalizeCustomerName(value);
  return (
    normalized.length > 0 &&
    normalized.length <= 50 &&
    /^[a-zA-Z\s\-']+$/.test(normalized)
  );
};

export const validatePhoneNumber = (value?: any) => {
  return value && validator.isMobilePhone(value);
};

export const validateZipCode = (value?: any) => {
  return value && value.length === 5;
};

export const validateStreet = (value?: any) => {
  return value && value.length >= 1;
};

export const validateCity = (value?: any) => {
  return value && value.length >= 1;
};

export const validateState = (value?: any) => {
  return value && value.length >= 1;
};
